import { Component, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { AdminCatalogModel } from 'src/app/model/admin/catalog';
import { CommonPersonModel } from 'src/app/model/common/person';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';
import { PERSON } from '../person.constants';
import { PersonService } from '../person.service';

@Component({
  selector: 'ms-common-person-form',
  templateUrl: './person-form.component.html',
  styleUrls: ['./person-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PersonFormComponent,
      multi: true,
    },
  ],
})
export class PersonFormComponent
  extends BaseValueAccessor<CommonPersonModel>
  implements OnInit
{
  readonly screen = PERSON;
  documentTypes: AdminCatalogModel[] = [];
  genders: AdminCatalogModel[] = [];
  maritalStatus: AdminCatalogModel[] = [];
  locations: SelectItem<KhuyanaSelectItemModel>[] = [];
  locationBornHelp: SelectItem<KhuyanaSelectItemModel> = { value: {} };

  constructor(protected service: PersonService) {
    super();
  }

  ngOnInit(): void {
    if (!this.value) {
      this.value = {};
    }
    const {
      documentTypes,
      genders,
      maritalStatus,
      locations,
      personData,
      locationBorn,
    } = this.service.readStore();
    personData.subscribe(
      (result) => (this.value = this.service.setPersonInformation(result))
    );
    documentTypes.subscribe(
      (result) => (this.documentTypes = result.filter((item) => item.status))
    );
    genders.subscribe(
      (result) => (this.genders = result.filter((item) => item.status))
    );
    maritalStatus.subscribe(
      (result) => (this.maritalStatus = result.filter((item) => item.status))
    );
    locations.subscribe((result) => (this.locations = result));
    locationBorn.subscribe((result) => (this.locationBornHelp = result));
  }

  queryLocations = (query: string) =>
    this.service.readLocations(query).subscribe();

  verifyPersonUniqueness = () => {
    if (
      !this.value.documentType ||
      !this.value.document ||
      this.value.document === ''
    ) {
      return;
    }

    const id = this.value.id;
    const type = this.value.documentType;
    const document = this.value.document;
    this.service.getPersonUnique(type, document, id);
  };

  verifyLocationBorn = () => {
    const isNotValidLocation =
      this.locationBornHelp == null ||
      this.locationBornHelp.value == null ||
      this.locationBornHelp.value.id == null;
    if (isNotValidLocation) {
      delete this.value.locationBorn;
    }
  };

  emailChanged = () =>
    (this.value.email = this.value
      .emailHelp!.map((email) => email.value)
      .join('|'));

  phoneChanged = () =>
    (this.value.phone = this.value
      .phoneHelp!.map((phone) => phone.value)
      .join('|'));

  onValueChanged = (e: any) => (this.value.dateBorn = e.value);
}
